import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;

export const TOKEN_KEY = "ks_session_token";

export const api = axios.create({
  baseURL: `${BACKEND_URL}/api`,
  withCredentials: true,
});

api.interceptors.request.use((config) => {
  const token = localStorage.getItem(TOKEN_KEY);
  if (token) config.headers.Authorization = `Bearer ${token}`;
  return config;
});

export const fetchMe = async () => {
  try {
    const res = await api.get("/auth/me");
    return res.data;
  } catch {
    return null;
  }
};

export const logout = async () => {
  try {
    await api.post("/auth/logout");
  } catch {}
  localStorage.removeItem(TOKEN_KEY);
};

// REMINDER: DO NOT HARDCODE THE URL, OR ADD ANY FALLBACKS OR REDIRECT URLS, THIS BREAKS THE AUTH
export const googleLogin = (redirectPath = "/portal") => {
  const redirectUrl = window.location.origin + redirectPath;
  window.location.href = `https://auth.emergentagent.com/?redirect=${encodeURIComponent(redirectUrl)}`;
};

export const INTEREST_LABELS = {
  land: "Land Acquisition",
  "luxury-apartments": "Luxury Apartments",
  "mutual-funds": "Mutual Funds",
  insurance: "Insurance",
  commercial: "Commercial Property",
};
